/** @prettier */
import { connect } from 'react-redux';
import { List } from 'immutable';
import RelatedEvents from '../../../components/SingleEventPage/RelatedEvents';
import { requestRelatedEvents } from '../../../modules/relatedEvents/actions';

const mapDispatchToProps = {
  requestRelatedEvents,
};

const EMPTY_LIST = new List();

function mapStateToProps(state, { eventId }) {
  let tag;
  const metaTags = state.getIn(['event', eventId, 'metaTags']);
  if (metaTags) {
    tag = metaTags.find(t => t.type === 'COMPETITION' || t.type === 'LOCATION', null, {}).urlName;

    if (!tag) {
      tag = metaTags.find(t => t.type === 'SPORT', null, {}).urlName;
    }
  }

  return {
    product: state.getIn(['application', 'product']),
    relatedEvents: state
      .getIn(['relatedEvents', tag], EMPTY_LIST)
      .map(id => state.getIn(['event', id], { id })),
    tag,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RelatedEvents);
